import { Validators } from '../../../utils/validators';
import { FormModel } from '../../../components/Form';
import dayjs from 'dayjs';

export const SearchBarForm = (
  strings: any,
  locations: [],
  eventTypes: [],
  // timeslots: [],
  isLocationDisabled: boolean,
): FormModel[] => {
  const today = dayjs(new Date());
  return [
    {
      label: `${strings.searchBar_Text_location}`,
      value: '',
      type: 'select',
      placeholder: strings.searchBar_Text_location,
      field: 'location',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      isMulti: true,
      responsive: { xs: 12, sm: 5.9 },
      size: 'small',
      disabled: isLocationDisabled,
    },
    {
      label: `${strings.searchBar_Text_eventType}`,
      value: '',
      type: 'drop-down',
      placeholder: strings.email_event_config_column_event_type,
      field: 'eventType',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 12, sm: 5.9 },
      options: eventTypes,
      size: 'small',
      // sx: { height: '54px' },
    },
    // {
    //   label: `${strings.searchBar_Text_TimeSlot}`,
    //   value: {},
    //   type: 'drop-down',
    //   placeholder: '',
    //   field: 'timeSlot',
    //   validators: [{ check: Validators.validateMandatoryField }],
    //   required: true,
    //   responsive: { xs: 12, sm: 5.9 },
    //   options: timeslots,
    //   size: 'small',
    //   // sx: { height: '54px' },
    // },
    {
      label: `${strings.common_text_startDate}`,
      value: '',
      autoFocus: true,
      type: 'date',
      typeValue: 'text',
      placeholder: '',
      field: 'startDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 5.9 },
      required: true,
      minDate: today,
      size: 'small',
    },
    {
      label: `${strings.common_text_endDate}`,
      value: '',
      autoFocus: false,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'endDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 5.9 },
      required: true,
      minDate: today,
      size: 'small',
    },
    {
      label: `${strings.timeSlot_column_startTime}`,
      value: '',
      size: 'small',
      type: 'time',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'startTime',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 5.9 },
      required: true,
    },
    {
      label: `${strings.timeSlot_text_endTime}`,
      value: '',
      size: 'small',
      type: 'time',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'endTime',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 5.9 },
      required: true,
    },
    {
      label: `${strings.searchBar_Text_NoOfGuest}`,
      value: '',
      typeValue: 'number',
      type: 'text',
      placeholder: '',
      field: 'guests',
      variant: 'outlined',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateInt, max: 100000 },
        // { check: Validators.noRoom, message: 'No. of guest exceeded' },
      ],
      required: true,
      responsive: { xs: 12, sm: 5.9 },
      size: 'small',
    },
  ];
};
